import { endpoints } from "@common";

const cis = endpoints.cis;
const prefix = '/api/manage';
export default {
    email: {
        send_code_get: `/EmailOTPSignup/SendCode`,
        validate_and_login: `/EmailOTPSignup/ValidateAndSign`,
    },
    account: {
        login: `/Login`,
        get_host_name: `${prefix}/GetHostingUrl`,
        change_password: `${prefix}/GetChangePasswordUrl`,
        get_user_profile: `${prefix}/GetUserPhoto`,
        logout: `${prefix}/GetLogoutUrl`,
        get_user_info: `${prefix}/GetUserDetail`,
        rego_login: `${prefix}/GetLoginUrl`,
        get_current_user: `${prefix}/GetCurrentUser`,
        logout_idp: `${prefix}/getexternallogouturl`,
        check_password_post: `${prefix}/FormPreflight`,
        change_password_post: `${prefix}/ChangeUserPassword`,
        verification_photo_post: `${prefix}/GetVerificationPhoto`,
        check_verification_code_post: `${prefix}/CheckVerification`,
        check_email_otp: `${prefix}/CheckEmailOtpCode`,
        check_verification_before_post: `${prefix}/CheckInforBeforSendCode`,
        go_to_change_password: `${prefix}/GetSSPRUrl`,
        check_captcha_post: `${prefix}/CheckVerification`,
        check_captcha_studentid_post: `/EmailOTPSignup/ChangePasswordSendCode`,
        verification_voice_post: `${prefix}/GetVerificationVoice?photoId={0}`
    },
    transfer: {
        get_data: `${prefix}/PublicIdentityProviderConfiguration`,
        get_redirect_uri: `/realm/processlogin?logicalName={0}&proxyState={1}&username={2}`,
        get_retrieve_redirect: `${prefix}/GetRetrieveCommonIdUrl?logicalName={0}&from={1}`,
        get_proxystate: `${prefix}/ResetProxyState?proxyState={0}`,
        get_quick_links: `${prefix}/GetVisibleApplications`
    },
    studentId: {
        IsUserEnabled_get: `${prefix}/IsUserEnabled`,
    },
    admin: {
        Report_AuditLogsPaging: `${prefix}/FindAuditAll`,
        Report_AuditLogsDownload: `${prefix}/DownloadAuditLogs`,
        Report_SingInLogsPaging: `${prefix}/FindSignInAll`,
        Report_SignInDownload: `${prefix}/DownloadSignIn`,
        Report_SuspiciousPaging: `${prefix}/FindSuspiciousAll`,
        Report_SuspiciousDownload: `${prefix}/DownloadSuspicious`,
        Report_ApplicationUsagePaging: `${prefix}/FindApplicationUsageAll`,
        Report_ApplicationUsageFindCisAll: `${prefix}/FindCisAll`,
        Report_ApplicationUsageFindCisAllDownload: `${prefix}/DownloadApplicationUsageAll`,
        Report_FindStaffAcessAllPaging: `${prefix}/FindStaffAcessAll`,
        Report_StaffAcessCreateRunNow: `${prefix}/CreateRunNow`,
        Report_StaffAcessDownload: `${prefix}/DownloadReport`,
        Report_StaffAcessUpdateScheduler: `${prefix}/UpdateScheduler`,
        Report_StaffAcessFindSchedulerRules: `${prefix}/FindSchedulerRules`,
        StudentManagement_Paging: `${prefix}/FindStudentManagementAll`,
        StudentManagement_ResetPassword: `${prefix}/ResetPassword?objectId={0}`,
        StudentManagement_ResetMFA: `${prefix}/ResetMFA?objectId={0}`,
        emailTemplate_Paging: `${prefix}/FindEmailTemplateAll`,
        emailTemplateUpdate_Put: `${prefix}/UpdateMail`,
        studentManagementUpdate_Put: `${prefix}/EditStudentManagement`,
        statusReasonFilter_Post: `${prefix}/FindReasonType`,
        GroupManagement_Paging_Post: `${prefix}/FindGroupsAll`,
        GroupManagement_details_Post: `${prefix}/FindGroupMember`,
        StudentManagement_ihlFilter_Post: `${prefix}/FindGroupsType`,
        GroupManagement_ihlFilter_Post: `${prefix}/FindGroupsIhlType`,
        GroupManagement_Download: `${prefix}/DownloadGroupsMember`,
        GroupManagement_FindRoleType: `${prefix}/FindRoleType`,
        Photo_save: `${prefix}/SaveTemplatesPhoto`,
    }
};